// extracted by mini-css-extract-plugin
module.exports = {"page":"_139Ijz","pageContent":"_1dxBw1","imageContainer":"_2jHI9_","icon":"_3tLCLe","formContainer":"_2RZ4nX"};